import { motion } from 'framer-motion';
import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export const KnowledgeBaseCardSkeleton = () => {
    return (
        <motion.div>
            <Card className="overflow-hidden">
                {/* Main Content */}
                <div className="p-5 space-y-4">
                    {/* Header with Icon, Title and ID */}
                    <div className="flex items-start justify-between gap-3">
                        <div className="flex items-start gap-3 flex-1 min-w-0">
                            {/* Icon */}
                            <Skeleton className="h-10 w-10 rounded-lg flex-shrink-0" />
                            
                            {/* Title */}
                            <div className="flex-1 min-w-0">
                                <Skeleton className="h-5 w-[180px] mb-1" />
                            </div>
                        </div>

                        {/* ID on Right */}
                        <Skeleton className="h-8 w-[140px]" />
                    </div>

                    {/* Grid */}
                    <div className="rounded-lg border border-border overflow-hidden bg-muted/30">
                        {/* Row 1 */}
                        <div className="grid grid-cols-3 divide-x divide-border">
                            <div className="h-11 flex items-center justify-center">
                                <Skeleton className="h-8 w-16" />
                            </div>
                            <div className="h-11 flex items-center justify-center">
                                <Skeleton className="h-8 w-16" />
                            </div>
                            <div className="h-11 flex items-center justify-center">
                                <Skeleton className="h-8 w-16" />
                            </div>
                        </div>
                        
                        {/* Divider */}
                        <div className="border-t border-border" />
                        
                        {/* Row 2 */}
                        <div className="grid grid-cols-3 divide-x divide-border">
                            <div className="h-11 flex items-center justify-center">
                                <Skeleton className="h-8 w-16" />
                            </div>
                            <div className="h-11 flex items-center justify-center">
                                <Skeleton className="h-8 w-16" />
                            </div>
                            <div className="h-11 flex items-center justify-center">
                                <Skeleton className="h-8 w-16" />
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </motion.div>
    );
}; 